export const imageMediaViewPorts = {
  maxLarge: '(max-width: 768px)',
  maxMediumLarge: '(max-width: 600px)',
  minLarge: '(min-width: 768px)',
  minMedium: '(min-width: 450px)',
  minMediumLarge: '(min-width: 600px)',
  minSmall: '(min-width: 370px)',
} as const;

export const imageTypeLocations = {
  concessions: {
    defaultConcession: '/img/concessions/concession-default-image.png',
    defaultConcessionLarge: '/img/concessions/concession-default-image@2x.png',
    defaultFountainFlavor: '/img/concessions/concessions_fountain_flavor_placeholder.png',
  },
  movieClub: {
    defaultMovieClub: '/img/movieclub-default-image.png',
  },
};
